import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-secure-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class AppLayoutSecureFooterComponent {}
